var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookIslands(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16.0001H16.0001C16.0001 15.9857 16.0001 15.9717 16.0001 15.9572C15.9858 15.9716 15.9716 15.9858 15.9573 16.0001Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9857 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09454 2.08682C5.5921 3.51176 3.51167 5.59213 2.08679 8.09457V15.9999H6.26073V6.26089V6.26076H15.9999C15.9999 4.94432 15.9999 3.6902 15.9999 2.08682H8.09454Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3153 8.34793H8.34778V8.34806L15.9998 16.0001H16C16 16.0001 16 14.6434 16 14.0325V14.0325Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16L21.8613 16.911H22.8192L22.0443 17.474L22.3403 18.3851L21.5652 17.822L20.7903 18.3851L21.0863 17.474L20.3114 16.911H21.2692L21.5652 16Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 17.6299L18.4834 18.0647L19.1608 17.3874L19.0109 18.3335L19.8644 18.7684L18.9183 18.9181L18.7685 19.8644L18.3335 19.0108L17.3875 19.1607L18.0649 18.4834L17.63 17.6299Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5653L16.911 21.2693L16.9111 20.3115L17.474 21.0863L18.3851 20.7903L17.822 21.5653L18.3851 22.3403L17.474 22.0443L16.9111 22.8192V21.8614L16 21.5653Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 25.5005L18.0648 24.647L17.3875 23.9697L18.3336 24.1196L18.7685 23.2661L18.9183 24.2122L19.8644 24.3619L19.0109 24.7969L19.1608 25.7431L18.4834 25.0656L17.63 25.5005Z",
    fill: "#F0F0F0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 27.1306L21.2692 26.2196H20.3113L21.0862 25.6566L20.7902 24.7456L21.5652 25.3086L22.3402 24.7456L22.0442 25.6566L22.8191 26.2196H21.8613L21.5652 27.1306Z",
    fill: "#F0F0F0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5006 25.5005L24.6471 25.0657L23.9698 25.7431L24.1196 24.7969L23.2661 24.3621L24.2122 24.2122L24.3621 23.2661L24.7969 24.1196L25.743 23.9697L25.0656 24.6471L25.5006 25.5005Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1307 21.5653L26.2196 21.8614V22.8192L25.6566 22.0443L24.7456 22.3403L25.3087 21.5653L24.7456 20.7903L25.6566 21.0863L26.2196 20.3115V21.2693L27.1307 21.5653Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5006 17.63L25.0658 18.4834L25.743 19.1607L24.7969 19.0109L24.3621 19.8644L24.2122 18.9182L23.2661 18.7684L24.1196 18.3335L23.9698 17.3875L24.6471 18.0647L25.5006 17.63Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookIslands);
export default __webpack_public_path__ + "static/media/cook-islands.f1e16247.svg";
export { ForwardRef as ReactComponent };